'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dGroupings$0024 from "./presto.-List-Groupings$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002463 from "./presto.-Presto-Router$$anon$63.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$62() {
  this.bki = null;
  this.bka = null;
  this.bkb = false;
  this.bkj = null;
  this.bkk = false;
  this.bkn = null;
  this.bkg = null;
  this.bkh = false;
  this.bkc = null;
  this.bkd = false;
  this.bke = null;
  this.bkf = false;
  this.bkl = false;
  this.bkm = false;
  this.bki = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bkn = "ListGroupings";
}
export { $c_Lpresto_PrestoRouter$$anon$62 as $c_Lpresto_PrestoRouter$$anon$62 };
$p = $c_Lpresto_PrestoRouter$$anon$62.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$62;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$62() {
}
export { $h_Lpresto_PrestoRouter$$anon$62 as $h_Lpresto_PrestoRouter$$anon$62 };
$h_Lpresto_PrestoRouter$$anon$62.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bki;
});
$p.M = (function() {
  if ((!this.bkb)) {
    this.bka = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bkb = true;
  }
  return this.bka;
});
$p.O = (function() {
  if ((!this.bkk)) {
    this.bkj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bkk = true;
  }
  return this.bkj;
});
$p.E = (function() {
  return this.bkn;
});
$p.t = (function() {
  if ((!this.bkh)) {
    this.bkg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bkh = true;
  }
  return this.bkg;
});
$p.N = (function() {
  if ((!this.bkd)) {
    this.bkc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bkd = true;
  }
  return this.bkc;
});
$p.Q = (function() {
  if ((!this.bkf)) {
    this.bke = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002463.$c_Lpresto_PrestoRouter$$anon$63();
    this.bkf = true;
  }
  return this.bke;
});
$p.v = (function() {
  if ((!this.bkm)) {
    this.bkl = false;
    this.bkm = true;
  }
  return this.bkl;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee454) => ((p) => \u03b4scrutinee454))($j_presto$002e$002dList$002dGroupings$0024.$m_Lpresto_ListGroupings$())));
});
var $d_Lpresto_PrestoRouter$$anon$62 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$62, "presto.PrestoRouter$$anon$62", ({
  OE: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$62 as $d_Lpresto_PrestoRouter$$anon$62 };
//# sourceMappingURL=presto.-Presto-Router$$anon$62.js.map
